module.exports = __webpack_public_path__ + "31189ecf70ef76fbee22a87b79ba9732.svg";